import React from 'react';
import FormItemButtonBaseControl from './FormItemButtonBaseControl';
import FormItemButton from '../FormItemButton';

import QueryUtil from '../../utils/QueryUtil';
import GOTUtil from '../../utils/GOTUtil';
import FormResourceUtil from '../../utils/FormResourceUtil';
import CommandResolver from '../../utils/CommandResolver';
import CommandActions from '../../actions/CommandActions';
import CmdTypeActions from '../../actions/CmdTypeActions';
import FocusActions from '../../actions/FocusActions';
import Warn from '../../utils/Warn';
import FormItemConst from '../FormItemConst';
import ServiceHelper from '../../remote/ServiceHelper';
import CommandHelper from '../../remote/CommandHelper';
import RecordsActions from '../../actions/RecordsActions';

import LayerManager from '../../manager/LayerManager';

import {CmdButtonOk} from '../../stores/CmdTypeStore';
import {ButtonShortCutStore} from '../../stores/CommandStore';


export default class FormItemButtonControl extends FormItemButtonBaseControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemButtonControl";
		this.module = module;
		if(!this.forLookup)
		{
			this.unsubscribeCmdButtonOk = CmdButtonOk.listen(this.onButtonOk.bind(this));

			if(this.isUnderButtonMenu())
			{
				this.unsubscribeButtonShortCutStore = ButtonShortCutStore.listen(this.onShortCut.bind(this));
			}
		}
	}

	isUnderButtonMenu()
	{
		if(this.parentXML)
		{
			if(this.parentXML.type == "ButtonMenu")
				return true;
		}
		return false;
	}

	onShortCut(keyCodeStr)
	{
		let shortCut = this.getProperty_ShortCut();
		if(shortCut == keyCodeStr)
		{
			this.beforeOK({target:this.jqueryComponent},true);
		}
	}

	onButtonOk(arg)
	{
		if(arg && arg.hasOwnProperty(this.xml.name))
		{
			this.initButtonOkCmd = arg;
		}
	}

	getStyle()
	{
		let _style = {};
		let layout = this.parentXML.Properties.Layout.Value;
		let parentType = this.parentXML.type;
		if(parentType == "ButtonGroup" && layout == "vertical")
		{
			_style["alignSelf"] = 'stretch';
		}
		//宽度高度的设置 其余都是在component中
		_style["padding"] = "1px 6px";
	

		let _width = this.xml.Properties.Width.Value;
		let _height =this.xml.Properties.Height.Value;

		if(_width)_style["width"] = _width+"px";
		if(_height)_style["height"] = _height+"px";

		return _style;
	}

	doSetEnableCmd(value)
	{
		this._cmdEditFalse = !value;
		CmdTypeActions.updateControlAllowEdit(this.xml.name,value,this.module.instanceUUId);
	}
	
	getJqueryItemUnderButtonMenu()
	{
		let $li = $("<li>");
		let $a = $("<a>").html(this.getProperty_Label()).click(this.beforeOK.bind(this));
		let allowEdit = this.getProperty_AllowEdit_Final();
		let visible = this.getProperty_Visible_Final();
		if(!allowEdit)$li.addClass("disabled").css({opacity:0.5});
		if(!visible)$li.css("display","none");
		$li.attr("componentName",this.xml.name);
		$li.attr("controlId",this.controlId);
		this.jqueryComponent = $a;
		return $li.append($a);
	}

	clickHandler(e)
	{
		//alert(this.getProperty_Label());
		document.execCommand("SaveAs");
	}

	getProperty_QueryType()
	{
		if(this.properties.hasOwnProperty("QueryType"))
			return this.properties.QueryType;
		return this.properties.ButtonType;
	}

	getProperty_MultiSelect()
	{
		return this.properties.MultiSelect;
	}

	getProperty_SaveRecord()
	{
		if(this.properties.hasOwnProperty("SaveRecord"))
			return this.properties.SaveRecord;
		return this.properties.AutoSaveRecord;
	}

	getProperty_DisplayStyle()
	{
		let _displayStyle = this.properties.DisplayStyle;
		try
		{
			_displayStyle = JSON.parse(_displayStyle);
		}
		catch(e)
		{
			_displayStyle = {};
		}
		return _displayStyle;
	}

	checkQuery()
	{
		if(!this.group)
			return null;
		var queryType = this.getProperty_QueryType();
		if(queryType == FormItemConst.BUTTON_PROPERTY_QUERYTYPE_SUBMIT_VALUE || queryType == FormItemConst.BUTTON_PROPERTY_QUERYTYPE_RESET_VALUE)
		{
			var parent = this.parentControl;
			while(parent && parent.classAlias && parent.classAlias != "FormItemDesignControl")
			{
				if(parent.classAlias == "FormItemGroupControl" && parent.getProperty_GroupType() == "Query")
				{
					return parent;
				}
				parent = parent.parentControl;
			}
		}
		// if(queryType == FormItemConst.BUTTON_PROPERTY_QUERYTYPE_DATASETRESET_VALUE){
		// 	this.group.reSetDataSetQuery(null,this.group.dataSetQueryTable);
		// 	QueryUtil.reverseOrderBy(this.group.dataSetQueryTable.queryOrderBy);
		// 	this.group.executeQueryAutoSaveStop(null,null,false,true);
		// }
		// if(queryType == FormItemConst.BUTTON_PROPERTY_QUERYTYPE_DATASETEXPORT_VALUE){
			
		// }
		return null;
	}
	
	findNoGroupEditor(node,source,sources,vector)
	{
		if(node.childrenControl)
		{
			for(let i = 0;i<node.childrenControl.length;i++)
			{
				var child = node.childrenControl[i];
				if(child.classAlias && child.classAlias.indexOf("Editor") != -1 && !child.group 
					&& child.getProperty_QuerySource() && child.getProperty_QuerySource() != "")
				{
					var cdsn = child.getProperty_QuerySource();
					var editords = sources[cdsn];
					var qf = child.getProperty_QueryField();
					if(editords && editords.group == source.group && qf != "" && qf)
					{
						vector.push(child);
					}
				}
				else
				{
					this.findNoGroupEditor(child,source,sources,vector);
				}
			}	
		}
		
	}

	//TODO 毫无意义
	checkMutiSelect()
	{
		return true;
		/*if(this.getProperty_MultiSelect() == false)
		{
			for each(var grid:FormItem_DataGrid in this.formDesign.grids)
			{
				if(grid.group == this.group)
				{
					var gridc:OrigDataGrid = grid.grid;
					if(gridc != null && gridc.selectedItems.length>1)
					{
						FadeAlert.show("当前按钮不支持记录多选后的操作");
						return false;
					}
				}
			}
			
		}
		
		return true;*/
	}
	
	saveRecord()
	{
		if(this.forLookup)
			return;
		var currentGroup = window.formModuleInstance.formDataSources.currentGroup;
		if(currentGroup)
		{
			if(this.getProperty_SaveRecord())
			{
				RecordsActions.RecordAutoSave(this.group);
			    if(window.rowChangeAutoSaveFail == true)
			    {
			      	//借用自动换行自动保存失败的标识
			        window.rowChangeAutoSaveFail = false;
			        return false;
			    }
			}
		}
		return true;
	}

	beforeOK(event,isShortCut = false)
	{
		//console.log("执行到了beforeOK-》"+this.xml.name);
		if(event.target)
		{
			if($(event.target).hasClass("disabled") || $(event.target).parent().hasClass("disabled"))
			{
				if(window.tasks)
				{
					let tasks = window.remainTasks;
					window.remainTasks = null;
					let task = tasks.shift();
			    	if(task)
			       		CommandResolver.doResolveTask(task,this.module,tasks);					
				}
				//console.log("执行到了209-》"+this.xml.name);
				return;
			}
		}
		if(this.forLookup)
		{
			return this.doOK();
		}
		if(typeof(isShortCut)=="object")
			isShortCut = false;
		var currentGroup = window.formModuleInstance.formDataSources.currentGroup;
		
		if(currentGroup == this.group)
		{
			//console.log("执行到了223-》"+this.xml.name);
			if(this.getProperty_SaveRecord() && currentGroup)
			{
				//console.log("执行到了226-》"+this.xml.name);
				if(this.getProperty_SaveRecord())
				{
					//console.log("执行到了229-》"+this.xml.name);
					RecordsActions.RecordAutoSave(this.group.groupAlias);
				    if(window.rowChangeAutoSaveFail == true)
				    {
				      	//借用自动换行自动保存失败的标识
				        window.rowChangeAutoSaveFail = false;
				        if(window.remainTasks)
						{
							let tasks = window.remainTasks;
							window.remainTasks = null;
							let task = tasks.shift();
					    	if(task)
					       		CommandResolver.doResolveTask(task,this.module,tasks);					
						}
				        return false;
				    }
				    return this.doOK();
				}
			
			}
			else if(!currentGroup)
			{
				return this.doOK();
			}
			else
			{
				return this.doOK();
			}
		}
		else
		{
			if(currentGroup)
			{
				RecordsActions.RecordAutoSave(currentGroup.groupAlias);
				//if(isShortCut)
					return this.doOK();
				//else
				//{
				//	if(window.remainTasks)
				//	{
				//		let tasks = window.remainTasks;
				//		window.remainTasks = null;
				//		let task = tasks.shift();
				//		if(task)
				//			CommandResolver.doResolveTask(task,this.module,tasks);					
				//	}
				//}
				
			}
			else
			{
				//console.log("执行到了281-》"+this.xml.name);
				//鼠标点击切换 快捷键不切换
				if(isShortCut)
					return this.doOK();	

				//if(this.groupAlias)

				if(this.parentControl && this.parentControl.classAlias == "FormItemButtonMenuControl")
				{
					return this.doOK();	
				}


			}
		}
	}

	doOK(isShortCut = false)
	{
		//FocusActions.scrollToAndFocus({groupAlias:"ItemTable",toIndex:30});return;
		/*var userGroupId = "test";
		var url="sysauthorityforIndustrialInternet/SysAuthoritySetup/SysAuthoritySetupForII.html?appId=000017&userGroupId="+userGroupId+"&userGroupName=车辆管理分组";
		url = encodeURI(url);
		//var iframe = $("<iframe>").css("width","100%").css("height","100%").css("border","none");
		

		window.open(url);
		//alert("dianji");
		return;*/
		var buttonds = null;var dataSource_Alias = GOTUtil.getPropertyValue(this.xml,"DataSource");
		if(this.module.formDataSources)
			buttonds = this.module.formDataSources.sources[dataSource_Alias];
		
		var flag_queryButton = false;
		if(this.getProperty_QueryType() && this.getProperty_QueryType() == FormItemConst.BUTTON_PROPERTY_QUERYTYPE_DATASETEXPORT_VALUE){
			this.group.dataSetExportBtn();
			return;
		}
		if(buttonds)
		{
			var fg = this.checkQuery();
			if(fg)
			{
				var editors = [];
				
				this.findNoGroupEditor(fg,buttonds,this.module.formDataSources.sources,editors);
				
				var queryType = this.getProperty_QueryType();
				if(queryType == FormItemConst.BUTTON_PROPERTY_QUERYTYPE_SUBMIT_VALUE)
				{
					var cqbak = this.group.currentQuery;
					this.group.reSetCurrentQuery();
					for(let i = 0;i<editors.length;i++)
					{	
						var editor = editors[i];

						let result = {};
						CommandActions.callComponentFunc(this.formId,editor.xml.id,"getInQueryGroupNow",null,result);
						if(result.ret == false)
							continue;
						CommandActions.callComponentFunc(this.formId,editor.xml.id,"getFormAutoQueryValue",null,result);
						var finalev = result.ret;
						var querysource = editor.getProperty_QuerySource();
						var formdatasource = this.module.formDataSources.sources[querysource];
						if(finalev == false){
							var array = [finalev];
						}else if(finalev=='null'){
							var array = [null]
						}
						else if(finalev == "''" || finalev == ""){
							var array = [null]
						}else if(typeof finalev =='string' && finalev.indexOf('只查空值') != -1 ){
							var array = ['']
						}else{
							if(finalev == true || finalev == false || !finalev){
								var array = [finalev];
							}else{
								var array = finalev.split("&");
							}

						}
						var _queryField = editor.getProperty_QueryField();
						for(let i = 0;i<array.length;i++)
						{

							if(window.isDataSetView){
								var itemValue = array[i];
								QueryUtil.dataSetViewcreateWhereItemByField(
									_queryField.split(".")[0],
									_queryField,
									formdatasource.alias,
									this.group.dataSetQueryTable,
									itemValue);
							}else{
								var itemValue = array[i];
								if(_queryField.indexOf(".")>2){
									QueryUtil.createWhereItemByField(
										_queryField,
										_queryField,
										formdatasource.alias,
										this.group.currentQuery,
										itemValue);
								}else{
								QueryUtil.createWhereItemByField(
									_queryField.split(".")[0],
									_queryField,
									formdatasource.alias,
									this.group.currentQuery,
									itemValue);
								}
							}

							
						}
					}
				}
				else if(queryType == FormItemConst.BUTTON_PROPERTY_QUERYTYPE_RESET_VALUE)
				{
					for(let i = 0;i<editors.length;i++)
					{
						let editor = editors[i];
						editor.record = "";
						let result = {};
						// TODO_YL  重置Enum  使得Enum 显示未选中
						if(editor.classAlias == "FormItemEnumEditorControl"){
							CommandActions.callComponentFunc(this.formId,editor.xml.id,"setdeselectAll");
						}else if(editor.classAlias == "FormItemBooleanEditorControl"){
							CommandActions.callComponentFunc(this.formId,editor.xml.id,"setDisplayFieldBooleanText");
						}else{
							// CommandActions.callComponentFunc(this.formId,editor.xml.id,"setDisplayFieldText",['-点此填值-']);
							CommandActions.callComponentFunc(this.formId,editor.xml.id,"setDisplayFieldDefText",['-点此填值-']);
							// CommandActions.callComponentFunc(this.formId,editor.xml.id,"setDisplayFieldText",[editor.getDefaultValue()]);

						}
						CommandActions.callComponentFunc(this.formId,editor.xml.id,"setQueryGroupEnable");
					}
					this.group.reSetCurrentQuery();
				}
				
				//formDesign.formModule.executeQuery(group,group.currentQuery);
				//return;
				flag_queryButton = true;
			}
		}
		
		if(flag_queryButton==false)
		{
			if(this.checkMutiSelect() == false)
				return;
		}

		var formId = this.module.formId;
		var btnName = this.xml.name;

		FocusActions.currentGroupSet(this.groupAlias,this.module.formId);
		
		LayerManager.executeLayerMethod(this.module,this.group,"buttonOK_"+btnName);

		var cmdargInfo = FormResourceUtil.getCommandArgMethodInfo("buttonOK_"+btnName,this.forLookup?"FormLookup":window.menuItemId,formId);	 
		if(cmdargInfo != null)
		{
			var _group = this.group;
			if(!_group)			
			{
				var _fds = this.module.formDataSources;
				if(_fds!=null)
				{
					_group = _fds.currentGroup;//_fds.firstGroup;
					if(!_group)_group = _fds.firstGroup;
				}
			}
			
			if(cmdargInfo.prefetch==true)
			{
				let tasks = cmdargInfo.commandResult.tasks;
				if(window.remainTasks)
				{
					tasks = window.remainTasks;
					window.remainTasks = null;
					if(cmdargInfo.commandResult.tasks)
					{
						let newTasks = cmdargInfo.commandResult.tasks.reverse();
						for(let i = 0;i<newTasks.length;i++)
						{
							tasks.unshift(newTasks[i]);
						}
					}				
				}
				CommandResolver.resolve(tasks, this.module, _group);
			}
			else
			{
				
				var arg = CommandResolver.getSendCmd(this.module,(!_group)?null:_group.groupAlias, cmdargInfo);

				if(window.lastFocusDataGrid)
				{
					if(window.lastFocusDataGrid.lastSelected)
					{
						let idx = window.lastFocusDataGrid.lastSelected.idx-1;
						if(idx<0)idx = 0;
						let column = window.lastFocusDataGrid._columns[idx];
						if(column)
						{
							let _argObject = {remoteClass:"java.util.Map"};
							_argObject["dataField"] = column.key;
							_argObject["formItemName"] = column.xmlName;
							_argObject["lastDataSource"] = window.lastFocusDataGrid.props.groupAlias;
							arg.argObject = _argObject;
						}
					}
					else
					{
						let _argObject = {remoteClass:"java.util.Map"};
						_argObject["lastDataSource"] = window.lastFocusDataGrid.props.groupAlias;
						arg.argObject = _argObject;
					}
					
				}

				var command = CommandHelper.createFormInstance(this.module.formName, "doButtonOK", "CommandResult")
											.appendArg(btnName, "String")
											.appendArg(arg, "CommandArg");
				var remoteArg = {command:command,resultFunction:this.rpc_result_doOK.bind(this,isShortCut),sync:false};
				return ServiceHelper.addTokenWithCommand(remoteArg);
			}
			
		}
		else
		{
			if(flag_queryButton==true)
			{
				if(!this.group)
				{
					Warn.show({text:"type为Submit的Button 请指定DataSource属性用来表示查询的数据源",confirm:{isShow:false,event:''}});
					return;
				}
				this.group.executeQuery(null,this.group.currentQuery);
			}
		}
	}

	rpc_result_doOK(isShortCut,data)
	{
		var result = data.result;
		var tasks;
		if(result)
		{
			tasks = result.tasks;
			if(window.remainTasks)
			{
				tasks = window.remainTasks;
				window.remainTasks = null;
				if(result.tasks)
				{
					let newTasks = result.tasks.reverse();
					for(let i = 0;i<newTasks.length;i++)
					{
						tasks.unshift(newTasks[i]);
					}
				}				
			}
			CommandResolver.resolve(tasks,this.module,this.group);
		}
		else
		{
			if(window.remainTasks)
			{
				tasks = window.remainTasks;
				window.remainTasks = null;
				let task = tasks.shift();
		    	if(task)
		       		CommandResolver.doResolveTask(task,this.props.control.module,tasks);					
			}
		}

		if(!isShortCut)
		{
			FocusActions.focusSet(this.formId,this.xml.id);
		}
	}

	getProperty_CSSStyle_Display()
	{
		let displayStyle = this.getProperty_DisplayStyle();

		//displayStyle = {cssStyle:{fontFamily:"微软雅黑",fontStyle:"italic",fontWeight:"bold",fontSize:20}};

		if(displayStyle && displayStyle.cssStyle)
			return displayStyle.cssStyle;
		return "";
	}	

	getComponentInstance(parent,forLookup)
	{
		let label = this._cmdLabel?this._cmdLabel:this.getProperty_Label();
		let layout = parent.Properties.Layout.Value;
		let commonProps = this.getCommonProps();
		let helpText = this.getProperty_HelpText();
	  	this.component = <FormItemButton displayStyle={this.getProperty_DisplayStyle()} key={this.xml.id} xml={this.xml} moduleInstanceId={this.module.instanceUUId} 
                parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias} initButtonOkCmd={this.initButtonOkCmd}
                label={label} customStyle={this.getStyle()} menuItemId={this.menuItemId} formId={this.formId} cssStyle={this.getProperty_CSSStyle_Display()}
                control={this} iconClass={this.getProperty_Icon()} helpText={helpText} {...commonProps}/>;
        return this.component;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemButtonControl.js